import { sizes, spacer } from '@guryou/html-theme';
import styled from 'styled-components';
const FormTag = styled.form`
  a {
    margin: 0 auto;
    width: 90%;
    display: block;
  }
`;
const FormActions = styled.div`
  width: 100%;
  margin: ${spacer.spacer4}px auto;
  text-align: center;
  button {
    display: flex;
    width: 80%;
    margin: ${spacer.spacer2}px auto;
    max-width: 300px;
  }
`;
const FormAvatarWrapper = styled.div`
  width: 90%;
  margin: 0 auto;
  max-width: ${sizes.small}px;
  display: flex;
  margin-bottom: ${spacer.spacer2}px;
  & img:hover {
    opacity: 0.9;
    cursor: pointer;
  }
`;
const HorizontalTimePickersWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin: 0 auto;

  & .MuiFormControl-root {
    width: auto;
    margin: 0;
    margin-left: ${spacer.spacer2}px;
  }
  & .MuiInput-root {
    width: 6rem;
  }
`;
export { FormActions, FormAvatarWrapper, FormTag, HorizontalTimePickersWrapper };